import { FC } from 'react';

import { clsx } from 'clsx';
import classes from './ToggleButtons.module.scss';
import ToggleButtonsItem from './ToggleButtonsItem';

type ToggleButtonsOption = { value: string; label: string };

type Props = Prettify<{
  className?: string;
  // The variant indicates the border radius of the toggle buttons
  variant: 'squared' | 'rounded';
  fullWidth?: boolean;
  toggleButtonsOptions: ToggleButtonsOption[];
  onToggle: (optionValue: string) => void;
  selectedValue: string;
}>;

export const ToggleButtons: FC<Props> = ({
  className,
  fullWidth,
  toggleButtonsOptions,
  onToggle,
  selectedValue,
  variant,
}) => {
  return (
    <div
      className={clsx('toggleGroup', classes.root, className, {
        [classes.fullWidth]: fullWidth,
      })}
    >
      {toggleButtonsOptions.map((item) => (
        <ToggleButtonsItem
          key={item.value}
          fullWidth={fullWidth}
          variant={variant}
          onClick={() => {
            onToggle(item.value);
          }}
          isSelected={selectedValue === item.value}
          disabled={selectedValue === item.value}
        >
          {item.label}
        </ToggleButtonsItem>
      ))}
    </div>
  );
};
